import React, { useState } from "react";
import { QrCode } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";

// Codice ritiro + QR della prenotazione premio (da mostrare in cassa; il POS lo annulla alla consegna)
export default function PickupQr({ reservation: r }) {
  const [open, setOpen] = useState(false);
  if (!r?.pickup_code || !["ready", "pickup_requested"].includes(r.status)) return null;
  const qr = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&margin=6&data=${encodeURIComponent(r.pickup_code)}`;
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-1 rounded-lg border border-amber-500/60 bg-amber-500/10 text-amber-200 px-2 h-8 text-xs font-mono font-bold" data-testid={`public-pickup-qr-${r.id}`}>
        <QrCode className="h-3.5 w-3.5" /> {r.pickup_code}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-xs bg-white text-zinc-900 text-center" data-testid="public-pickup-qr-dialog">
          <DialogHeader><DialogTitle className="text-center">Ritiro premio</DialogTitle></DialogHeader>
          <div className="font-semibold">{r.reward_name}</div>
          <img src={qr} alt={`QR ${r.pickup_code}`} className="mx-auto h-56 w-56 rounded-xl ring-1 ring-zinc-200" data-testid="public-pickup-qr-img" />
          <div className="font-mono text-2xl font-extrabold tracking-widest" data-testid="public-pickup-code">{r.pickup_code}</div>
          <p className="text-xs text-zinc-600">Mostra questo QR (o il codice) in cassa: il negozio lo annulla alla consegna e scala {r.points_cost} punti{r.contribution_eur > 0 ? ` + € ${Number(r.contribution_eur).toFixed(2)} di contributo` : ""}. Vale una sola volta.</p>
        </DialogContent>
      </Dialog>
    </>
  );
}
